export const perPageFilter = [
  {
    label: '20 per page',
    value: 20,
  },
  {
    label: '50 per page',
    value: 50,
  },
  {
    label: '100 per page',
    value: 100,
  },
];

export const productsFilter = [
  {
    label: 'Product Name',
    value: 'title',
  },
  {
    label: 'Date Uploaded',
    value: 'created_at',
  },
  {
    label: 'Model/SKU',
    value: 'model',
  },
];

export const retailers = [
  {
    label: 'Sales Channels (All)',
    value: 'all',
  },
];

export const retailersFilter = [
  {
    label: 'Sales Channel Name',
    value: 'supplier_retailers.retailer_display_name',
  },
  {
    label: 'Request Date',
    value: 'created_at',
  },
];
